export default "__VITE_ASSET__edcbaed8__"